import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Grid,
  Stack,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import "../App.css";
import PageHeader from "../components/PageHeader";
import { Link, useNavigate } from "react-router-dom";
import { serviceProviderSignup } from "../apis";
import _ from "lodash";
import ReactFlagsSelect from "react-flags-select";

const ServiceProviderRegister = () => {
  const [enteredEmail, setEnteredEmail] = useState("");
  const [enteredPassword, setEnteredPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [enteredFirstName, setEnteredFirstName] = useState("");
  const [enteredLastName, setEnteredLastname] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("GB");
  const [termsCheck, setTermsCheck] = useState(true);
  const [res, setRes] = useState({});
  const [openSnack, setOpenSnack] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));
    if (_.isEmpty(user)) {
      navigate("/serviceProviderRegister");
    } else {
      navigate("/");
    }
  }, []);

  const RegisterButtonHandler = async () => {
    if (
      enteredFirstName != "" &&
      enteredLastName != "" &&
      enteredEmail != "" &&
      enteredPassword != "" &&
      selectedCountry != "" &&
      termsCheck != false &&
      enteredPassword == confirmPassword
    ) {
      const data = await serviceProviderSignup({
        firstName: enteredFirstName,
        lastName: enteredLastName,
        fullName: enteredFirstName + " " + enteredLastName,
        email: enteredEmail,
        password: enteredPassword,
        country: selectedCountry,
        isActive: false,
        isRejected: false,
        infoFilled: false,
      });
      setRes(data.data);
    } else {
      setOpenSnack(true);
    }
  };

  const handleClose = () => {
    setOpenSnack(false);
  };

  useEffect(() => {
    if (res.success == true) {
      localStorage.setItem("user-info", JSON.stringify(res.userInfo));
      localStorage.setItem("user-type", "service provider");
      navigate("/service-provider/info");
    }
  }, [res]);

  return (
    <>
      <PageHeader title="Register as Partner" crossIcon />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          variant="filled"
          onClose={handleClose}
        >
          Please fill all of the required information in order to proceed!
        </Alert>
      </Snackbar>
      <Container maxWidth="sm" className="mt-16">
        <Stack>
          <Stack>
            <Stack direction="row" spacing={4} justifyContent="space-between">
              <Stack style={{ width: "45%" }}>
                <Typography style={{ fontWeight: "bold" }}>
                  First Name
                </Typography>
                <TextField
                  required
                  id="outlined-basic"
                  placeholder="Enter your First Name"
                  variant="outlined"
                  onChange={(e) => setEnteredFirstName(e.target.value)}
                  size="small"
                />
              </Stack>
              <Stack style={{ width: "45%" }}>
                <Typography style={{ fontWeight: "bold" }}>
                  Last Name
                </Typography>
                <TextField
                  required
                  id="outlined-basic"
                  placeholder="Enter your Last Name"
                  variant="outlined"
                  size="small"
                  onChange={(e) => setEnteredLastname(e.target.value)}
                />
              </Stack>
            </Stack>
            <Typography style={{ fontWeight: "bold" }} className="mt-13">
              Email
            </Typography>
            <TextField
              required
              id="outlined-basic"
              placeholder="Email"
              variant="outlined"
              onChange={(e) => setEnteredEmail(e.target.value)}
              size="small"
            />
            <Typography style={{ fontWeight: "bold" }} className="mt-13">
              Password
            </Typography>
            <TextField
              required
              id="outlined-basic"
              placeholder="Password"
              variant="outlined"
              type="password"
              onChange={(e) => setEnteredPassword(e.target.value)}
              size="small"
            />
            <Typography style={{ fontWeight: "bold" }} className="mt-13">
              Confirm Password
            </Typography>
            <TextField
              required
              id="outlined-basic"
              placeholder="Password"
              variant="outlined"
              type="password"
              style={
                enteredPassword != confirmPassword
                  ? { border: "1px solid red" }
                  : null
              }
              onChange={(e) => setConfirmPassword(e.target.value)}
              size="small"
            />
            {/* <Typography style={{ fontWeight: "bold" }} className="mt-13">
              Country
            </Typography>
            <ReactFlagsSelect
              selected={selectedCountry}
              onSelect={(code) => setSelectedCountry(code)}
              searchable
            /> */}
            <FormGroup>
              <FormControlLabel
                className="checkbox mt-13"
                size="small"
                control={
                  <Checkbox onChange={(e) => setTermsCheck(e.target.checked)} />
                }
                label="Yes, I understand and agree to the Terms of Service and Privacy Policy."
              />
            </FormGroup>

            <Button
              variant="contained"
              onClick={RegisterButtonHandler}
              className="mt-13 primary-button"
            >
              Register
            </Button>

            <span className="text-align-center mt-13">
              Already Registered?{" "}
              <Link
                to="/login"
                className="text-decoration-none text-bold default-color"
              >
                Sign In
              </Link>
            </span>
          </Stack>
        </Stack>
      </Container>
    </>
  );
};

export default ServiceProviderRegister;
